import {
  MutateOptions,
  QueryOptions,
  useCreate,
  useDelete,
  useGetOne,
  useUpdate,
} from "@imminently/react/store/query";
import { useResources } from "@imminently/react/ui/resource/hooks";
import moment from "moment";

import { PatientEncounter } from "./types";

export const useEncounter = (id: string, options?: QueryOptions) =>
  useGetOne<PatientEncounter>(id, "encounters", id, options);

export const useEncounters = (key: string, filter = {}) =>
  useResources<PatientEncounter>("encounters", key, filter);

export const useCreateEncounter = (options: MutateOptions) =>
  useCreate<PatientEncounter>("encounters", options);

export const useUpdateEncounter = (options: MutateOptions) =>
  useUpdate<PatientEncounter>("encounters", options);

export const useDeleteEncounter = (options: MutateOptions) =>
  useDelete<PatientEncounter>("encounters", options);

/** Returns the Length of Stay value in milliseconds */
export const getLengthOfStay = (encounter: PatientEncounter) => {
  const start = encounter.arrived;

  // Expected patients don't have a LOS value
  if (!start || encounter.status === "expected") return null;

  const end = encounter.dischargeDateTime || encounter.discharged || new Date();
  const duration = moment(end).diff(start);

  return duration > 0 ? duration : null;
};

/** Returns the time between triaged and arrived */
export const getTimeToTriage = (encounter: PatientEncounter) => {
  const triage = encounter.triaged;
  const arrived = encounter.arrived;

  if (!triage || !arrived) return null;

  const duration = moment(arrived).diff(triage);

  return duration > 0 ? duration : null;
};

/** Returns the time since triage */
export const getTimeSinceTriage = (encounter: PatientEncounter) => {
  const triage = encounter.triaged;

  if (!triage) return null;

  const duration = moment().diff(triage);

  return duration > 0 ? duration : null;
};